const TestimonialsData = [
  {
    image: "/assets/Testimonial/t2.png",
    name: "Anjali Verma",
    message:
      "The mehendi artists at Royal Mehendi Services made my wedding day unforgettable. The designs were intricate and stunning!",
    service: "Bridal Mehendi",
    rating: 5,
  },
  {
    image: "/assets/Testimonial/t2.png",
    name: "Ritika Sharma",
    message:
      "I booked their mehendi service for my engagement, and they exceeded my expectations. The team was professional and punctual.",
    service: "Engagement Mehendi",
    rating: 4,
  },
  {
    image: "/assets/Testimonial/t3.png",
    name: "Pooja Mishra",
    message:
      "The mehendi designs were so unique, and the color came out beautifully. Thank you for making my event special!",
    service: "Party Mehendi",
    rating: 5,
  },
  {
    image: "/assets/Testimonial/t4.png",
    name: "Simran Kaur",
    message:
      "I loved the traditional mehendi designs they created for my family function. Highly recommend their service!",
    service: "Traditional Mehendi",
    rating: 4,
  },
  {
    image: "/assets/Testimonial/t5.png",
    name: "Neha Gupta",
    message:
      "The mehendi artists were so talented and friendly. Everyone at the event loved their designs and work ethic.",
    service: "Festival Mehendi",
    rating: 5,
  },
  {
    image: "/assets/Testimonial/t6.png",
    name: "Deepika Jain",
    message:
      "Their modern mehendi designs are perfect for someone looking for something unique and elegant. I was amazed by their creativity!",
    service: "Modern Mehendi",
    rating: 4,
  },
  {
    image: "/assets/Testimonial/7.png",
    name: "Aarti Yadav",
    message:
      "The bridal mehendi was so detailed and vibrant. I couldn't have asked for a better start to my wedding celebrations!",
    service: "Bridal Mehendi",
    rating: 5,
  },
  {
    image: "/assets/Testimonial/t8.jpeg",
    name: "Kavita Singh",
    message:
      "They are the best in the business! From intricate designs to quick execution, they delivered more than I expected.",
    service: "Sangeet Mehendi",
    rating: 5,
  },
  {
    image: "/assets/Testimonial/t11.png",
    name: "Meera Patel",
    message:
      "I booked Royal Mehendi Services for my baby shower, and the guests loved their mehendi art. Great job by the team!",
    service: "Baby Shower Mehendi",
    rating: 4,
  },
  {
    image: "/assets/Testimonial/t2.png",
    name: "Shweta Tiwari",
    message:
      "Their mehendi artists were so professional and skilled. My sisters and I were thrilled with our beautiful designs!",
    service: "Family Mehendi",
    rating: 5,
  },
];

export default TestimonialsData;